<template>
  <header class="business-header">
    <div class="container">
      <div class="row">
        <div class="col-12 mt-0 d-none d-sm-block">
          <h1 class="display-1 text-center mt-4">{{title}}</h1>
          <h3 class="display-5 text-center mt-4">{{subTitle}}</h3>
        </div>
        <div class="col-12 mt-0 d-sm-none">
          <h1 class="display-3 text-center  mt-4">{{title}}</h1>
          <h4 class="text-center mt-4">{{subTitle}}</h4>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: String,
    subTitle: String,
  },
};
</script>

<style scoped>
  .business-header {
    height: 70vh;
    min-height: 300px;
    background: url('../assets/bgc.jpg') center center no-repeat scroll;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card {
    height: 100%;
  }
  .display-5 {
    font-size: 36px;
    margin-top: -12px!important;
  }
  @media screen and (max-width: 600px) {
    .business-header {
      height: 50vh;
    }
  }

</style>
